import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className"];
import { defineUrlIcon } from '@carnica/graphics';
import { useFlag } from '@carnica/utils/hooks';
import React, { forwardRef } from 'react';
import { cnBem } from "../../../../shared/lib";
import styles from "./styles.pcss";
var IconSticker = defineUrlIcon({
  url: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4LjI3NTEgMTAuNzE2NkMxOC4yNTg0IDEwLjg3NSAxOC4yMzM0IDExLjAyNSAxOC4xOTE3IDExLjE3NUMxNy4zMjUxIDEwLjQ0MTYgMTYuMjAwMSA5Ljk5OTk4IDE0Ljk3NTEgOS45OTk5OEMxMi4yMTY3IDkuOTk5OTggOS45NzUwNyAxMi4yNDE2IDkuOTc1MDcgMTVDOS45NzUwNyAxNi4yMjUgMTAuNDE2NyAxNy4zNSAxMS4xNTAxIDE4LjIxNjZDMTEuMDAwMSAxOC4yNTgzIDEwLjg1MDEgMTguMjgzMyAxMC42OTE3IDE4LjNDOS45ODM0MSAxOC4zNjY2IDkuMjU4NDEgMTguMzMzMyA4LjUwODQxIDE4LjIwODNDNS4wODM0MSAxNy42MjUgMi4zMjUwNyAxNC44NSAxLjc1ODQxIDExLjQxNjZDMC44MTY3NCA1LjcwODMxIDUuNjgzNDEgMC44NDE2NDIgMTEuMzkxNyAxLjc4MzMxQzE0LjgyNTEgMi4zNDk5OCAxNy42MDAxIDUuMTA4MzEgMTguMTgzNCA4LjUzMzMxQzE4LjMwODQgOS4yODMzMSAxOC4zNDE3IDEwLjAwODMgMTguMjc1MSAxMC43MTY2WiIgc3Ryb2tlPSIjOThBMEIwIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xOC4xOTE4IDExLjE3NUMxOC4wNzUxIDExLjU4MzMgMTcuODU4NCAxMS45NSAxNy41NTAxIDEyLjI1ODNMMTIuMjMzNCAxNy41NzVDMTEuOTI1MSAxNy44ODMzIDExLjU1ODQgMTguMSAxMS4xNTAxIDE4LjIxNjdDMTAuNDE2OCAxNy4zNSA5Ljk3NTEgMTYuMjI1IDkuOTc1MSAxNUM5Ljk3NTEgMTIuMjQxNyAxMi4yMTY4IDEwIDE0Ljk3NTEgMTBDMTYuMjAwMSAxMCAxNy4zMjUxIDEwLjQ0MTcgMTguMTkxOCAxMS4xNzVaIiBzdHJva2U9IiM5OEEwQjAiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==',
  ratio: 1
});
var cnStickerButton = cnBem('sticker-button', styles);
export var StickerButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useFlag = useFlag(),
    _useFlag2 = _slicedToArray(_useFlag, 2),
    hovered = _useFlag2[0],
    setHovered = _useFlag2[1];
  return /*#__PURE__*/React.createElement(IconSticker, _extends({}, props, {
    className: cnStickerButton(null, [className]),
    color: hovered ? 'primary-invert' : 'tertiary',
    onMouseEnter: setHovered.on,
    onMouseLeave: setHovered.off,
    ref: ref,
    size: 20,
    tagName: "button",
    type: "button",
    "data-t-id": "ui-StickerButton"
  }));
});